const Auth = {
    isAutenthicated() {
        if (!sessionStorage.getItem('isAuthenticated')) return false
        if (this.isTokenExpired()) {
            this.logout()
            return false
        }
        return true
    },
    getToken() {
        return sessionStorage.getItem('Auth_Token')
    },
    isTokenExpired() {
        const loginTime = sessionStorage.getItem('Auth_LoginTime')
        const expiresIn = sessionStorage.getItem('Auth_ExpiresIn')
        if (!loginTime || !expiresIn) return true
        const elapsed = (Date.now() - parseInt(loginTime)) / 1000
        return elapsed >= parseInt(expiresIn)
    },
    login(token, expiresIn) {
        sessionStorage.setItem('isAuthenticated', 'true')
        sessionStorage.setItem('Auth_Token', token)
        sessionStorage.setItem('Auth_ExpiresIn', expiresIn)
        sessionStorage.setItem('Auth_LoginTime', Date.now().toString())
    },
    renewToken(newToken) {
        sessionStorage.setItem('Auth_Token', newToken)
        sessionStorage.setItem('Auth_LoginTime', Date.now().toString())
    },
    logout() {
        sessionStorage.removeItem('isAuthenticated')
        sessionStorage.removeItem('Auth_Token')
        sessionStorage.removeItem('Auth_ExpiresIn')
        sessionStorage.removeItem('Auth_LoginTime')
    },
}
export default Auth
